import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import Swal from 'sweetalert2';
import { RedesSociales } from '../../../../core/services/redes-sociales.service';

@Component({
  selector: 'app-redes-sociales-dialog',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDialogActions,
    MatDialogContent,
  ],
  templateUrl: './redes-sociales-dialog.html',
  styleUrl: './redes-sociales-dialog.scss',
})
export class RedesSocialesDialog {
  private fb = inject(FormBuilder);

  guardando = false;

  constructor(
    private dialogRef: MatDialogRef<RedesSocialesDialog>,
    private redesSocialesService: RedesSociales,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  form = this.fb.group({
    redSocial: ['', Validators.required],
    usuario: ['', Validators.required],
  });

  get item(): any {
    return this.data?.redSocial;
  }

  get esEdicion(): boolean {
    return !!this.item?.id;
  }

  ngOnInit(): void {
    if (this.item) {
      this.form.patchValue({
        redSocial: this.item.redSocial ?? '',
        usuario: this.item.usuario ?? '',
      });
    }
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  guardar(): void {
    if (this.guardando) return;

    const valores = this.form.getRawValue();
    const payload = {
      redSocial: (valores.redSocial ?? '').trim(),
      usuario: (valores.usuario ?? '').trim(),
    };

    if (this.form.invalid || !payload.redSocial || !payload.usuario) {
      this.form.markAllAsTouched();
      return;
    }

    this.guardando = true;

    const peticion = this.esEdicion
      ? this.redesSocialesService.actualizarRedesSociales(this.item.id, payload)
      : this.redesSocialesService.crearRedesSociales(payload);

    peticion.subscribe({
      next: (respuesta) => {
        Swal.fire({
          icon: 'success',
          title: this.esEdicion ? 'Red social actualizada' : 'Red social agregada',
          showConfirmButton: false,
          timer: 2000,
        }).then(() => this.dialogRef.close(respuesta?.data ?? respuesta));
      },
      error: (error) => {
        this.guardando = false;

        Swal.fire({
          icon: 'error',
          title: 'No se pudo guardar',
          text:
            error?.error?.message?.join?.(', ') ??
            error?.error?.message ??
            'Ocurrió un error al guardar la red social.',
          showConfirmButton: false,
          timer: 2000,
        });
      },
    });
  }
}
